import { useMutation } from '@tanstack/react-query';
import { Col, DatePicker, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { DefaultOptionType } from 'antd/es/select';
import { useEffect, useState } from 'react';

import { ApproveApi } from 'apis/ApproveApis';
import { FormFilter, InputForm, SelectForm } from 'components';
import Content from 'layouts/Content';

const spanCol = 6;

interface Iprops {
  isOpen: boolean;
  onCancel: () => void;
  onFinish: (values: any) => void;
}

interface IForm {
  approvalType: string;
  senderName: string;
  statusApproval: string;
  date: string;
}

const FilterApprovePage = ({ isOpen, onCancel, onFinish }: Iprops) => {
  const [form] = useForm<IForm>();

  const [aprTypeOptions, setAprTypeOptions] = useState<DefaultOptionType[]>([]);
  const [aprStatusOptions, setAprStatusOptions] = useState<DefaultOptionType[]>(
    [],
  );

  const { mutate: getApprovalType } = useMutation({
    mutationFn: () => ApproveApi.getApprovalTypes(),
    onSuccess: (res) => {
      const items = res.data?.getApproval?.items;
      const options: DefaultOptionType[] = items?.map((item: any) => ({
        label: item.name,
        value: item.id,
      }));

      setAprTypeOptions(options);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { mutate: getApprovalStatus } = useMutation({
    mutationFn: () => ApproveApi.getApprovalStatus(),
    onSuccess: (res) => {
      const items = res.data?.getCode?.items;
      const options: DefaultOptionType[] = items?.map((item: any) => ({
        label: item.name,
        value: item.id,
      }));

      setAprStatusOptions(options);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    getApprovalType();
    getApprovalStatus();
  }, []);

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Content isOpen={isOpen}>
      <FormFilter onFinish={onFinish} onCancel={handleCancel} form={form}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Loại phê duyệt" name="approvalType">
              <SelectForm
                placeholder="Chọn loại phê duyệt"
                options={aprTypeOptions}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item name="senderName" label="Người gửi duyệt">
              <InputForm placeholder="Nhập tên người gửi duyệt" />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Trạng thái phê duyệt" name="statusApproval">
              <SelectForm
                placeholder="Chọn trạng thái phê duyệt"
                options={aprStatusOptions}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item name="date" label="Ngày gửi">
              <DatePicker
                inputReadOnly={true}
                placeholder="Chọn ngày gửi"
                className="w-full h-[40px]"
                format={{ format: 'DD/MM/YYYY' }}
              />
            </Form.Item>
          </Col>
        </Row>
      </FormFilter>
    </Content>
  );
};

export default FilterApprovePage;
